module.exports = __webpack_public_path__ + "static/media/logo.c3ec1d0b.png";